import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../components/nav/Header.js';
import Footer from '../components/nav/Footer.js';
import content from '../assets/content.json';

export default function Carriers() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{content.metadata.carriersMetadata.title}</title>
        <meta name="description" content={content.metadata.carriersMetadata.description} />
      </Helmet>
      <Header />
      <div className="carriers-container">
        <iframe
          src={`${process.env.PUBLIC_URL}/TrustPro_Carrier_Collage_v9.html`}
          title="TrustPro Carriers"
          style={{
            width: '100%',
            height: '100vh',
            border: 'none',
            display: 'block'
          }}
        />
      </div>
      <Footer />
    </HelmetProvider >
  );
}
